export const REQUEST = 'Admin/Plans/REQUEST';
export const SUCCESS = 'Admin/Plans/SUCCESS';
export const ERROR = 'Admin/Plans/ERROR';

export const SET = 'Admin/Plans/SET';
export const DELETED = 'Admin/Plans/DELETED';
export const UPDATED = 'Admin/Plans/UPDATED';